import { cloneDeep } from 'lodash';
import { sportCategories } from '../../data-types/sports/sportsConstants';
import {
  DELETE_SPORTSBOOK_EVENT,
  RESET_SPORTSBOOK_EVENTS,
  SET_SPORTSBOOK_EVENTS,
  SportsbookEventsActionType,
  SportsbookEventsState,
  UPDATE_SPORTSBOOK_EVENT,
} from '../types/sportsbookEventsType';

export const initialSportsbookEventsState: SportsbookEventsState = {};

export const sportsbookEventsReducer = (
  state = initialSportsbookEventsState,
  action: SportsbookEventsActionType,
): SportsbookEventsState => {
  switch (action.type) {
    case SET_SPORTSBOOK_EVENTS: {
      return { ...action.meta };
    }
    case UPDATE_SPORTSBOOK_EVENT: {
      const { meta } = action;

      let event = meta;
      const key = `${event.sportId}-${event.id}`;

      // TODO: !!!HACKY solution below!!!
      // TODO: Delete the below lines after `races:get` and `event:update` are fixed
      // TODO: by the BE to return the correct `highlighted` status
      // TODO: This was decided by PO to have this hacky fix
      const currentEvent = state[key];
      if (currentEvent && event.sportId === sportCategories.HORSES) {
        event = { ...event, highlighted: currentEvent.highlighted || event.highlighted };
      }

      return { ...state, [key]: event };
    }
    case DELETE_SPORTSBOOK_EVENT: {
      const {
        meta: { sportId, eventId },
      } = action;

      const events = cloneDeep(state);
      const key = `${sportId}-${eventId}`;
      if (events[key]) {
        delete events[key];
      }

      return { ...events };
    }
    case RESET_SPORTSBOOK_EVENTS:
      return {};
    default:
      return { ...state };
  }
};
